var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsTemplate = function SvgFormsTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.167h7.5m-7.5-3.334h5.625M6.187 2.75h-3.75V16.5h13.126V2.75h-3.75m-5.626 0V4h5.625V2.75m-5.624 0V1.5h5.625v1.25",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsTemplate;